module.exports = __webpack_public_path__ + "static/media/photo180.5bbb2bf0.jpg";